export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/info-circle-white.46133588.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};